module.exports = __webpack_public_path__ + "static/media/cirrus-s.539d2be8.png";